import OrganizationWebHook from './OrganizationWebHook';
import type { IOrganizationWebHooks } from './OrganizationWebHooks.interface';

export default class OrganizationWebHooks implements IOrganizationWebHooks {
  contactCreated: OrganizationWebHook;
  contactUpdated: OrganizationWebHook;
  dealCreated: OrganizationWebHook;
  dealUpdated: OrganizationWebHook;
  dealChangesDueDate: OrganizationWebHook;
  dealChangesStage: OrganizationWebHook;
  dealChangesWorkflow: OrganizationWebHook;
  dealChangesStatus: OrganizationWebHook;
  dealChangesAttachments: OrganizationWebHook;
  dealChangesRequiredDocuments: OrganizationWebHook;
  dealChangesOwner: OrganizationWebHook;
  noteCreated: OrganizationWebHook;
  noteUpdated: OrganizationWebHook;

  static build = (data: IOrganizationWebHooks) => new OrganizationWebHooks(data);
  static blank = () => new OrganizationWebHooks();

  /**
   * Constructor
   * @param {IOrganizationWebHooks} data
   */
  constructor(data?: IOrganizationWebHooks) {
    this.contactCreated = new OrganizationWebHook(data?.contactCreated);
    this.contactUpdated = new OrganizationWebHook(data?.contactUpdated);
    this.dealCreated = new OrganizationWebHook(data?.dealCreated);
    this.dealUpdated = new OrganizationWebHook(data?.dealUpdated);
    this.dealChangesDueDate = new OrganizationWebHook(data?.dealChangesDueDate);
    this.dealChangesStage = new OrganizationWebHook(data?.dealChangesStage);
    this.dealChangesWorkflow = new OrganizationWebHook(data?.dealChangesWorkflow);
    this.dealChangesStatus = new OrganizationWebHook(data?.dealChangesStatus);
    this.dealChangesAttachments = new OrganizationWebHook(data?.dealChangesAttachments);
    this.dealChangesRequiredDocuments = new OrganizationWebHook(
      data?.dealChangesRequiredDocuments
    );
    this.dealChangesOwner = new OrganizationWebHook(data?.dealChangesOwner);
    this.noteCreated = new OrganizationWebHook(data?.noteCreated);
    this.noteUpdated = new OrganizationWebHook(data?.noteUpdated);
  }
}
